<template>
  <b-form class="package__form" v-on:submit.prevent="onSubmit" @reset="onReset">
    <b-card class="create-packages__helper" style="margin-bottom: 15px;">
      <span style="font-size: 16px; display: block; color: #575757;">Add Package</span>
      Use this flow to add packages to the device manager. 
      These packages can be used for various actions such as OTA jobs.
    </b-card>
    <b-form-group
      id="input-group-1"
      label="Label:"
      label-for="input-label"
      description="Enter a label for this package."
    >
      <b-form-input
        id="input-label"
        v-model="form.label"
        type="text"
        placeholder="Enter label"
        required
      ></b-form-input>
    </b-form-group>
    
    <b-form-group
      id="input-group-2"
      label="Version:"
      label-for="input-major"
      description="Enter a version for this package."
      :state="versionState"
      :invalid-feedback="invalidVersion"
    >
      <div class="create-packages__version">
        <b-form-input
          id="input-major"
          v-model="form.major"
          type="number"
          placeholder=""
          required
        ></b-form-input>
        .
        <b-form-input
          id="input-minor"
          v-model="form.minor"
          type="number"
          placeholder=""
          required
        ></b-form-input>
        .
        <b-form-input
          id="input-build"
          v-model="form.build"
          type="number"
          placeholder=""
          required
        ></b-form-input>
      </div>
    </b-form-group>

    <b-form-group
      id="input-group-3"
      label="File:"
      label-for="input-file"
      description="Select package file."
      :state="packageState"
      :invalid-feedback="packageMessage"
    >
      <b-form-file
        accept="application/zip"
        v-model="form.file"
        :state="Boolean(form.file)"
        placeholder="Choose a package file or drop it here..."
        drop-placeholder="Drop package file here..."
      ></b-form-file>
    </b-form-group>

    <b-form-group
      id="input-group-4"
      label="Type:"
      label-for="input-type"
      description="Select package type."
    >
      <b-form-select v-model="form.packageType" 
        :options="[{ text: 'Select Package Type', value: null }, ...configuration.packages.map((item) => {return { text: item, value: item }})]"  
        placeholder="Select the package subtype..."></b-form-select>
    </b-form-group>

    <div class="create-package__form-buttons">
      <b-button type="reset">Reset</b-button>
      <b-button type="submit" variant="primary" :disabled="!isValid()">Add</b-button>
    </div>
  </b-form>
</template>
<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import BedManagerService from "../BedManager.service";
import DeviceManagerAPIService from "../../../shared/services/api/DeviceManager.service";

const moment = require("moment");

Vue.use(VueToast);
Vue.use(Loading);

export default {
  name: "CreatePackages",
  components: { },
  data() {
    return {
      console: console,
      moment: moment,
      bedManagerService: BedManagerService,
      deviceManagerAPIService: DeviceManagerAPIService,

      latestPackage: null,
      form: {
        label: "",
        version: "",
        major: 1,
        minor: 0,
        build: 0,
        file: null,
        packageType: null,
      },
      signedUrl: null,
    };
  },
  computed: {
    formFile() {
      return this.form.file;
    },
    configuration() {
      return this.bedManagerService.configuration;
    },
    major() {
      return this.form.major;
    },
    minor() {
      return this.form.minor;
    },
    build() {
      return this.form.build;
    },
    versionState() {
      return ![...this.bedManagerService.packages.data].find(pkg => pkg.version === this.form.version);
    },
    invalidVersion() {
      if ([...this.bedManagerService.packages.data].find(pkg => pkg.version === this.form.version)) {
        return 'Version already exists.'
      }
      return ''
    },
    packageState() {
      return !this.form.file || 
        this.form.file.size <= 
          (this.bedManagerService.configuration.awsPackageSizeLimit ? this.bedManagerService.configuration.awsPackageSizeLimit : 250000000);
    },
    packageMessage() {
      return !this.form.file || 
        this.form.file.size <= 
          (this.bedManagerService.configuration.awsPackageSizeLimit ? this.bedManagerService.configuration.awsPackageSizeLimit : 250000000) ? "" : "Package size exceeds 250mb."
    }
  },
  watch: {
    async formFile() {
      if (this.form.file && this.form.file.name) {
        this.signedUrl = 'gathering';
        const signedUrl = await this.deviceManagerAPIService.fetchSignedUrl(this.form.file.name);
        if (signedUrl && signedUrl.message) this.signedUrl = signedUrl.message;
        else { this.signedUrl = null; this.onReset(); }
      }
    },
    major() {
      this.form.version = `${this.major}.${this.minor}.${this.build}`;
    },
    minor() {
      this.form.version = `${this.major}.${this.minor}.${this.build}`;
    },
    build() {
      this.form.version = `${this.major}.${this.minor}.${this.build}`;
    }
  },
  mounted() {
    if (this.bedManagerService.packages && Array.isArray(this.bedManagerService.packages.data)) {
      const sorted = [...this.bedManagerService.packages.data].sort((a, b) => b._id.localeCompare(a._id));
      if (sorted.length) {
        this.latestPackage = sorted[0];
        this.determineNextVersion();
      } 
    }
  },
  unmounted() {},
  methods: {
    isValid() {
      return this.signedUrl && 
        this.signedUrl !== 'gathering' && 
        this.form && this.form.file && 
        this.form.packageType && 
        Number.isInteger(Number(this.form.major)) &&
        Number.isInteger(Number(this.form.minor)) &&
        Number.isInteger(Number(this.form.build)) &&
        ![...this.bedManagerService.packages.data].find(pkg => pkg.version === this.form.version) &&
        this.form.file.size <= (this.bedManagerService.configuration.awsPackageSizeLimit ? this.bedManagerService.configuration.awsPackageSizeLimit : 250000000); 
    },
    determineNextVersion() {
      if (this.latestPackage) {
        const [major, minor, build] = this.latestPackage.version.split('.');
        this.form.major = Number(major);
        this.form.minor = Number(minor);
        this.form.build = Number(build) + 1;
      }
    },
    async onSubmit() {
      const willProceed = 
        confirm("Before submitting this package, it is critical that you ensure that the correct package files were selected before submitting. Press ok to continue, otherwise press cancel.");
      const action = {
        label: 'Processing package upload. Please wait...',
      };
      if (willProceed) {
        action.action = this.deviceManagerAPIService.postPackageWithSignedUrl(this.form.file, this.signedUrl).then(() => {
          this.deviceManagerAPIService.postPackage({
            signedUrl: this.signedUrl,
            label: this.form.label,
            version: `${this.form.major}.${this.form.minor}.${this.form.build}`,
            packageType: this.form.packageType,
            fileName: this.form.file.name,
          }).then(() => {
            action.label = 'Package uploaded. The package will show as available shortly.';
            setTimeout(() => {
              this.bedManagerService.actions.splice(this.bedManagerService.actions.indexOf(action), 1);
            }, 5000);
          });
        }).catch(() => {
          setTimeout(() => {
            action.label = 'Package failed to upload.';
            setTimeout(() => {
              this.bedManagerService.actions.splice(this.bedManagerService.actions.indexOf(action), 1);
            }, 5000);
          }, 3000);
        });
        this.bedManagerService.actions = action;
      }  
      this.$emit('exit', true);
    },
    onReset() {
      this.form = {
        label: "",
        version: "",
        major: 0,
        minor: 0,
        build: 0,
        file: null,
        packageType: "",
      }
      this.determineNextVersion();
    }
  },
};
</script>

<style lang="scss">
  #add-item-modal {
    label {
      color: #404040;
    }
  }

  .package__form {
    > .form-group {
      padding: 0 15px;
      margin: 0 15px;
    }

    .card {
      border: none;
    }
  }

  .create-packages__helper {
    background: #f2f2f2;
    color: #a9a9a9; 
    font-size: 12px;
    border: none;
    border-bottom: 1px solid rgb(210 210 210 / 13%);
  }

  .create-packages__version {
    display: flex; 
    gap: 2px;
    align-items: center;

    > input {
      height: 30px;
      width: 50px;
      padding: 2px;
      padding-left: 6px;
    }
  }

  .create-package__form-buttons {
    display: flex;
    padding: 15px 30px;
    justify-content: flex-end;
    align-items: center;
    gap: 15px;

    .btn-secondary {
      background-color: #fff;
      color: #848484;
    }
  }
</style>
